export const MIN_INTERVAL = 1000
export const CONTENTS_GAP = 12
export const CONTENTS_SCALE = 0.85